export class StripeService {
  // One-off credits
  static async createCheckoutSession(userId, quantity, successUrl, cancelUrl, allowPromotionCodes) {
    try {
      const response = await fetch('/.netlify/functions/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          mode: 'payment',
          success_url: successUrl,
          cancel_url: cancelUrl,
          allow_promotion_codes: !!allowPromotionCodes,
          line_items: [
            {
              price_data: {
                currency: 'usd',
                product_data: { name: 'K9 Links Credits' },
                unit_amount: quantity * 100,
              },
              quantity: 1,
            },
          ],
          metadata: {
            user_id: userId,
            credit_quantity: String(quantity),
          },
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || 'Failed to create checkout session');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating credit checkout session:', error);
      throw error;
    }
  }

  // Subscriptions
  static async createSubscriptionCheckoutSession(userId, priceId, successUrl, cancelUrl, allowPromotionCodes) {
    try {
      const response = await fetch('/.netlify/functions/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          mode: 'subscription',
          success_url: successUrl,
          cancel_url: cancelUrl,
          allow_promotion_codes: !!allowPromotionCodes,
          line_items: [
            { price: priceId, quantity: 1 },
          ],
          metadata: { user_id: userId },
          subscription_data: { metadata: { user_id: userId } },
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || 'Failed to create subscription session');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating subscription checkout session:', error);
      throw error;
    }
  }
}
